import { field } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";

@model("ContactPeppolEndpoint")
export class ContactPeppolEndpoint {
	public ID:number = 0;
	public ContactID:number = 0;
	@field("string")
	public SchemeID: string = "";
	@field("string")
	public Number: string = "";
	@field("string")
	public Label: string = "";
	@field("string")
	public FullID:string = "";

	public IsDefault: boolean = false;

	public constructor(data?: any) {
		if (!data) return;
		this.ID = data.ID;
		this.ContactID = data.ContactID;
		this.SchemeID = data.SchemeID;
		this.Number = data.Number;
		this.Label = data.Label;
		this.FullID = data.SchemeID + ":" + this.Number;
	}

	public getJSON(): any {
		return {
			ID: this.ID,
			ContactID: this.ContactID,
			SchemeID: this.SchemeID,
			Number: this.Number,
			Label: this.Label,
			IsDefault: this.IsDefault
		};
	}

	public getFullID(): string {
		if (!this.Number) return "";
		if (!this.SchemeID) return this.Number;
		return `${this.SchemeID}:${this.Number}`;
	}

	public getDisplayName(): string {
		const id = this.getFullID();
		if (this.Label) {
			return id ? `${this.Label} (${id})` : this.Label;
		}
		return id;
	}
}
